import { NovaLogger } from 'owa-analytics-nova-logger';
import { redactDevHostAppVersion } from '@1js/px-telemetry-hostapp-middleware';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { getComplianceEnvironment } from 'owa-loki-request/lib/configuration/getComplianceEnvironment';
import { getPlatformType } from 'owa-loki-request/lib/configuration/getPlatformType';

export const RingAppName = 'PeopleHighlightsRing';

export default function initializeRingNovaLogger(): void {
    // Initialize nova logger for Reading Pane Persona Ring.
    const mailboxInfo = getModuleContextMailboxInfo();
    NovaLogger.initializeNovaLogger(RingAppName, {
        ingestionKey: getRingIngestionKey(),
        mailboxInfo,
        middlewares: [redactDevHostAppVersion],
        complianceEnvironment: getComplianceEnvironment(mailboxInfo),
        platformType: getPlatformType(),
    });
}

function getRingIngestionKey() {
    // People highlights aria tenant
    return '136931d8fe8a4f5ab06063c9a693c8e6-1bf92fb9-223c-4b4b-8807-4114496f98af-7433';
}
